import { AppConstants, Interfaces } from "@/core/Export";
import DataSource from "devextreme/data/data_source";
import "devextreme/data/odata/store";
import store from "@/store";

class Odata {
  public getDSByName(name: string) {
    if (!name) return null;
    var params = name.split(".");
    var func = this[params[0]];
    var prm = "";
    if (params.length > 1) {
      prm = params[1];
    }
    return func(prm, this);
  }

  //   public supportRequests(filter) {
  //     return new DataSource({
  //       store: {
  //         type: "odata",
  //         url: AppConstants.Http.BaseODataUrl + "View_SupportRequest",
  //         version: 4,
  //         beforeSend: e => {
  //           e.headers = this.appEnv.Headers;
  //         }
  //       },
  //       filter: filter.length > 0 ? filter : null
  //     });
  //   }

  get appEnv() {
    return store.state.appEnv;
  }
}

export const odata = new Odata();
